 // https://skybox-vr-player.s3.cn-north-1.amazonaws.com.cn/release/mac-arm64/SKYBOX-arm64-1.1.5.dmg
 // https://skybox-vr-player.s3.cn-north-1.amazonaws.com.cn/release/mac-x64/SKYBOX-x64-1.1.5.dmg
//  https://skybox-vr-player.s3.cn-north-1.amazonaws.com.cn/release/win/SKYBOX-x64-1.1.5.exe

 export const downloadUrlMacArm64 = 'https://skybox-vr-player-s3.skybox.xyz/mac-arm64/SKYBOX.dmg';
 export const downloadUrlMacX64 = 'https://skybox-vr-player-s3.skybox.xyz/mac-x64/SKYBOX.dmg';
 export const downloadUrlWin = 'https://skybox-vr-player-s3.skybox.xyz/win/SKYBOX-x64.exe';
 export const downloadUrlWin8 = 'https://download.skybox.xyz/skybox-pc-client/SKYBOX_for_Windows_0.2.4.exe';